import React, { useCallback, useEffect, useState } from 'react';
import { Flex, Box, Text } from 'rebass/styled-components';
import { ProfilePicture } from '@getro/rombo';
import PropTypes from 'prop-types';
import { ChevronRight } from 'lucide-react';
import { TableRow } from '../agGrid/components/tableRow';

export const CompanyNameRenderer = ({ data, ...props }) => {
  const { node } = props;
  const [expanded, setExpanded] = useState(node.expanded);

  useEffect(() => {
    const expandListener = (event) => setExpanded(event.node.expanded);

    node.addEventListener('expandedChanged', expandListener);

    return () => {
      node.removeEventListener('expandedChanged', expandListener);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onClick = useCallback(() => node.setExpanded(!node.expanded), [node]);

  const original = data?.original ? data.original : node?.allLeafChildren?.[0]?.data?.original;
  if (!original) {
    return props.value;
  }

  if (original.id === 'load-more' || !props.value) {
    return '';
  }

  return (
    <TableRow
      {...props}
      data={{
        ...data,
        original,
      }}
      sx={{ alignItems: 'center' }}
    >
      <Flex alignItems="center" justifyContent="flex-start" p="8px">
        <Flex alignItems="center" justifyContent="center" sx={{ gap: '8px' }}>
          <Box minWidth="24px" minHeight="24px" width="24px" height="24px">
            <ProfilePicture variant="square" imageUrl={original.logoUrl} name={original.name} />
          </Box>
          <Text
            fontWeight="medium"
            fontSize="14px"
            sx={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {original.name}
          </Text>
          <Text fontWeight="medium" fontSize="14px">
            {original.contactsCount ? `(${original.contactsCount})` : ''}
          </Text>
          <Box
            style={{
              paddingLeft: `${node.level * 15}px`,
              height: '16px',
              width: '16px',
            }}
          >
            <Box
              as={ChevronRight}
              size={16}
              sx={{
                cursor: 'pointer',
                transform: expanded ? 'rotate(90deg)' : 'rotate(0deg)',
                display: 'inline-block',
                color: 'neutral.500',
              }}
              onClick={onClick}
            />
          </Box>
        </Flex>
      </Flex>
    </TableRow>
  );
};

CompanyNameRenderer.propTypes = {
  data: PropTypes.object,
  context: PropTypes.object,
  value: PropTypes.string,
  node: PropTypes.object,
};

CompanyNameRenderer.defaultProps = {
  data: {},
  context: {},
  value: '',
  node: {},
};
